// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"318":"edba4e55","429":"a5d194f1","548":"e722a49e"}[chunkId] + ".chunk.css";
};